export default __webpack_public_path__ + "static/media/3334 spice rack C top.ff1a96c0.png";